import { render, staticRenderFns } from "./InstallationService.vue?vue&type=template&id=ffa48932&"
import script from "./InstallationService.vue?vue&type=script&lang=js&"
export * from "./InstallationService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports